import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { VhQueryAutoWeb } from 'vhautowebdb';
import { NzDrawerPlacement } from 'ng-zorro-antd/drawer';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'atw-config-mobile-product',
  templateUrl: './config-mobile.component.html',
  styleUrls: ['./config-mobile.component.scss']
})
export class CountDownProductConfigMobileComponent   {
   
}
